import gql from 'graphql-tag';

export const FULL_CATALOG_SYSTEM_FIELDS = gql`
  fragment FullCatalogSystemFields on CatalogSystemType {
    id
    name
  }
`;

export const FULL_CATALOG_SUBSYSTEM_FIELDS = gql`
  fragment FullCatalogSubsystemFields on CatalogSubsystemType {
    id
    name
  }
`;

export const FULL_CATALOG_INFORMATION_FIELDS = gql`
  fragment FullCatalogInformationFields on CatalogInformationType {
    id
    title
    detail
    dataName
    questionType
    units
    allowsOther
    requiresLocations
    requiresMedias
    requiresDeficiencyCondition
    requiresLimitationCondition
    isMultiSelect
    options
    description
    visualAidTitle
    visualAidKbaUrl
    visualAidImageUrl
  }
`;
